import AjusteDetalhe from '@/views/pages/patrimonio/ajuste/visualizacao/AjusteDetalhe.vue'

export default [
    {
        path: '/ajuste/:ajusteId/visualizar',
        name: 'AjusteDetalhe',
        component: AjusteDetalhe,
        meta: {
            page: {
                title: 'Visualizar Ajuste'
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
        },
    }
]
